export const agentMixins = {
  inject: [
    'merchantId',
    'readOnly',
    'isEdit',
    'isMerchant',
    'getNeedOcr',
    'form',
    'businessForm',
    'picForm',
    'settleForm',
    'getNeedMcc',
    'licenseExpiryDate',
    'idCardExpiryDate',
    'businessInfoMethod',
    'getParentData',
    'settleToMethod',
    'storeToLocal',
    'checkValidate',
    'setUpgrade',
    'upgradeState',
    'isChain' // 是否是连锁版商户
  ],
  computed: {
    needOcr () {
      return this.getNeedOcr()
    },
    needMcc () {
      return this.getNeedMcc()
    },
    passed () {
      return this.isEdit && (this.form.statusDesc === '审核通过' || this.isUpgrade)
    },
    notPassed () {
      return this.isEdit && this.form.statusDesc === '审核不通过'
    },
    isUpgrade () {
      return this.upgradeState() ? this.upgradeState().isUpgrade : ''
    },
    canUpgrade () {
      return this.upgradeState() ? this.upgradeState().canUpgrade : ''
    }
  },
  data () {
  },
  methods: {
    /**
     * @description 有效期赋值
     * @param {Object} value 结果对象
     */
    getExpiryDate (value) {
      const start = value.valueName + 'Start'
      const end = value.valueName + 'End'
      this.businessForm[start] = value.dateStart
      this.businessForm[end] = value.longTermTag ? '2099-12-30' : value.dateEnd
      if (!this.isEdit && !this.readOnly) {
        this.storeToLocal()
      }
    },
    /**
     * @description 图片上传成功的回调
     */
    uploadSuccess (data, ref = data.valueName) {
      if (data.error_code === '0') {
        const name = data.valueName
        if (name.includes('.')) {
          this[name.split('.')[0]][name.split('.')[1]] = data.path
          this.$parent.$parent.$refs[ref.split('.')[0]].validateField(ref.split('.')[1])
        } else {
          this.picForm[name] = data.path
          this.$refs.picForm.validateField(name)
        }
        if (!this.isEdit && !this.readOnly) {
          this.storeToLocal()
        }
      }
    },
    // 批量上传成功回调
    multiUploaded (data) {
      if (this.picForm[data.valueName] === '') {
        this.picForm[data.valueName] += data.path
      } else {
        this.picForm[data.valueName] += ',' + data.path
      }
    },
    // 批量上传删除某一张回调
    multiDelete (data) {
      if (this.picForm[data.valueName].indexOf(',' + data.path) >= 0) {
        this.picForm[data.valueName] = this.picForm[data.valueName].replace(',' + data.path, '')
      } else {
        this.picForm[data.valueName] = this.picForm[data.valueName].replace(data.path, '')
      }
      if (this.picForm[data.valueName].indexOf(',') === 0) {
        this.picForm[data.valueName] = this.picForm[data.valueName].substring(1)
      }
    },
    /**
     * @description 银行分行选中回调
     * @param {Object} val 组件传的参数，分行选中数据
     */
    getBankBranch (val) {
      this.settleForm.FBankTypeCode = val.bankNameCode// 银行类型编码
      this.settleForm.FBankCityCode = val.bankCityCode// 银行类型编码
      this.settleForm.FBankAreaCode = val.bankAreaCode// 银行类型编码
      this.settleForm.unionpay = val.bankBranchCode// 分行id
      if (!this.isEdit && !this.readOnly) {
        this.storeToLocal()
      }
    },
    // orc识别数据回填
    getOCRResult (data, ref = data.valueName) {
      if (data.success) {
        switch (data.valueName) {
          case 'businessForm.licensePic': {
            // 营业执照
            this.businessForm.licenseFullName = data.name
            this.businessForm.merchantName = data.name
            this.businessForm.license = data.licenseNo
            let start, end
            try {
              if (data.endDate) {
                if (data.endDate.includes('长期') || data.endDate.includes('不约定期限') || data.endDate.includes('永久')) {
                  start = data.startDate ? this.formatDate(data.startDate) : ''
                  end = '2099-12-30'
                } else {
                  start = this.formatDate(data.startDate)
                  end = this.formatDate(data.endDate)
                }
              } else {
                if (data.period.includes('长期') || data.period.includes('不约定期限') || data.period.includes('永久')) {
                  start = data.period.includes('至') ? this.formatDate(data.period.split('至')[0]) : ''
                  end = '2099-12-30'
                } else {
                  start = this.formatDate(data.period.split('至')[0])
                  end = this.formatDate(data.period.split('至')[1])
                }
              }
            } catch (error) {
              console.log(error)
              start = ''
              end = ''
            }
            this.licenseExpiryDate.dateStart = start
            this.licenseExpiryDate.dateEnd = end === '2099-12-30' ? '' : end
            this.licenseExpiryDate.longTermTag = end === '2099-12-30'
            this.$parent.$parent.$refs.businessInfo.$refs.licenseExpiryDate.$refs.form.validate()
            this.checkValidate('businessForm', ['licenseFullName', 'merchantName', 'license'])
            break
          }
          case 'businessForm.idcardFrontPic': {
            // 身份证人像面
            this.businessForm.legalName = data.name
            this.businessForm.idCardNo = data.idcard
            this.checkValidate('businessForm', ['legalName', 'idCardNo'])
            break
          }
          case 'businessForm.idcardBackPic': {
            // 身份证国徽面
            const start = this.formatDate(data.validDate.split('-')[0])
            const end = this.formatDate(data.validDate.split('-')[1])
            this.idCardExpiryDate.dateStart = start
            this.idCardExpiryDate.dateEnd = end === '2099-12-30' ? '' : end
            this.idCardExpiryDate.longTermTag = end === '2099-12-30'
            this.$parent.$parent.$refs.businessInfo.$refs.idCardExpiryDate.$refs.form.validate()
            break
          }
          case 'settleForm.bankCardFrontPic': {
            this.settleForm.bankCardNo = data.bankcardNo
            this.checkValidate('settleForm', 'bankCardNo')
            if (this.settleForm.bankCardNo && /^\d{16,19}$/.test(this.settleForm.bankCardNo)) {
              this.lumhBankCardId = this.settleForm.bankCardNo
            }
            this.settleForm.FBankTypeCode = ''
            this.settleForm.FBankAreaCode = ''
            this.settleForm.FBankCityCode = ''
            this.settleForm.unionpay = ''
            break
          }
          case 'settleForm.nonLegIdcardFrontPic': {
            // 非法人身份证人像面
            this.settleForm.holder = data.name
            this.settleForm.accountIdCardNo = data.idcard
            break
          }
        }
      }
      // 保存上传的图片
      const name = data.valueName
      if (name.includes('.')) {
        this[name.split('.')[0]][name.split('.')[1]] = data.path
        this.$parent.$parent.$refs[ref.split('.')[0]].validateField(ref.split('.')[1])
      } else {
        this.picForm[name] = data.path
        this.$refs.picForm.validateField(name)
      }
      if (!this.isEdit && !this.readOnly) {
        this.storeToLocal()
      }
    },
    // 日期格式转换，含有年月日或纯数字，转换成-
    formatDate (str) {
      // ocr识别出错兼容
      if (!str || str === '无') {
        return ''
      }
      try {
        if (str.includes('年')) {
          const year = str.split('年')[0].trim()
          let month = str.split('年')[1].split('月')[0].trim()
          // 月份需要两位数-ocr可能会返回"2023年12月3日"和"2023年12月03日"
          if (parseInt(month) < 10) {
            month = '0' + parseInt(month)
          }
          let day = str.split('年')[1].split('月')[1].split('日')[0].trim()
          // 日期需要两位数
          if (parseInt(day) < 10) {
            day = '0' + parseInt(day)
          }
          return year + '-' + month + '-' + day
        } else if (str.length >= 8) {
          const year = str.substr(0, 4)
          const month = str.substr(4, 2)
          const day = str.substr(6, 2)
          return year + '-' + month + '-' + day
        } else {
          return ''
        }
      } catch (error) {
        console.log(error)
        return ''
      }
    },
    /**
     * @description 重置营业执照的校验
     */
    resetLicense () {
      this.businessForm.license = ''
      this.businessForm.licensePic = ''
      this.businessForm.licenseFullName = ''
      this.businessForm.licenseStart = ''
      this.businessForm.licenseEnd = ''
      this.licenseExpiryDate = {
        dateStart: '',
        dateEnd: '',
        longTermTag: false
      }
      const that = this
      this.$parent.$parent.$refs.businessForm.clearValidate('license')
      this.$nextTick(function () { that.$parent.$parent.$refs.businessForm.clearValidate('licensePic') })
      this.$parent.$parent.$refs.businessForm.clearValidate('licenseFullName')
      if (this.$refs.licenseExpiryDate) {
        this.$refs.licenseExpiryDate.$refs.form.clearValidate('dateStart')
        this.$refs.licenseExpiryDate.$refs.form.clearValidate('dateEnd')
      }
    }
  }
}
